import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
// component, hooks
import PublicDataset from "./publicDataset/PublicDataset";
import PrivateDataset from "./privateDataset/PrivateDataset";
// store
import { StoreContext } from "../../../../../../store/StoreProvider";
// config,utils
import fireAuth from "../../../../../../api/firebase/auth/utils";

// style

const GroupTabCtx = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  // local state
  // hooks
  //
  const isLoggedIn = fireAuth.isLoggedIn(user);

  return (
    <Box>
      <PublicDataset />
      {isLoggedIn && <PrivateDataset />}
    </Box>
  );
};

GroupTabCtx.propTypes = {};

GroupTabCtx.defaultProps = {};

export default GroupTabCtx;
